// A hidden field is declared like any other form field, but the visitor never
// sees an input for it: the public form reads its value from the query
// parameter named by the field and submits it with the rest, so an ad click id
// or partner ref carried on a signup link ends up in the customer's custom
// fields and, from there, in the customer export.
//
// It is a type rather than a flag on "text" because required, unique and
// options have no meaning for a field nobody fills in — as a type they simply
// don't apply instead of having to be suppressed everywhere.
export const HIDDEN_FIELD_TYPE = "hidden";

/**
 * @param {string} type - A form field's type, or a custom field's field_type.
 * @returns {boolean} True when the value comes from the URL rather than the visitor.
 */
export function isHiddenFieldType(type) {
  return type === HIDDEN_FIELD_TYPE;
}

/**
 * Suggest a query parameter name from a field's label.
 * Only a starting point — the marketing site owns the real parameter name, so
 * this is editable and is never applied on top of one already set.
 * @param {string} label - The label staff typed for the field.
 * @returns {string} A lowercase, underscore-separated parameter name.
 */
export function toParameterName(label) {
  return (label ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_-]/g, "");
}
